import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 20);
  });
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Products',
    href: '#products'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <>
      <motion.header initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm py-3" data-id="element-86">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
          <div className="flex items-center justify-between" data-id="element-88">
            {/* Logo */}
            <a href="#home" className="flex items-center group relative z-50" data-id="element-89">
              <motion.img initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 1,
              delay: 0.2
            }} src="https://cdn.magicpatterns.com/uploads/6TXc6bvjECFRnTgAPwPHHs/SHIVAY_LOGO.png" alt="Shivaay Fashion" className="h-12 md:h-14 w-auto object-contain" data-id="element-90" />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8" data-id="element-91">
              {navLinks.map((link, index) => <motion.a key={link.name} href={link.href} initial={{
              opacity: 0,
              y: -20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.1 * index + 0.3
            }} className="text-sm font-medium tracking-wide text-gray-800 hover:text-[#1e3a8a] transition-colors relative group" data-id="element-92">
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#dc2626] transition-all duration-300 ease-out group-hover:w-full" data-id="element-93"></span>
                </motion.a>)}

              <motion.a href="#contact" initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.8
            }} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-[#1e3a8a] text-white px-6 py-2.5 rounded-full text-sm font-semibold shadow-lg hover:bg-[#152c6b] hover:shadow-xl transition-all duration-300" data-id="element-94">
                Get Quote
              </motion.a>
            </nav>

            {/* Mobile Menu Button */}
            <motion.button initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} className="md:hidden p-2 text-gray-800 z-50 relative" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-95">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-96" /> : <Menu className="w-6 h-6" data-id="element-97" />}
            </motion.button>
          </div>
        </div>
      </motion.header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-98">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-0 z-40 bg-white md:hidden flex flex-col justify-center items-center" data-id="element-99">
            <div className="flex flex-col space-y-6 text-center" data-id="element-100">
              {navLinks.map((link, i) => <motion.a key={link.name} href={link.href} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1 * i
          }} className="text-2xl font-bold text-gray-900 hover:text-[#1e3a8a]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-101">
                  {link.name}
                </motion.a>)}
              <div className="pt-8 flex flex-col space-y-4" data-id="element-102">
                <a href="mailto:shivaayfashions9@gmail.com" className="flex items-center justify-center text-gray-600" data-id="element-103">
                  <Mail className="w-5 h-5 mr-2 text-[#dc2626]" data-id="element-104" />
                  shivaayfashions9@gmail.com
                </a>
                <a href="tel:+919870622203" className="flex items-center justify-center text-gray-600" data-id="element-105">
                  <Phone className="w-5 h-5 mr-2 text-[#dc2626]" data-id="element-106" />
                  +91-9870622203
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}